import type {
  StorefrontTagAssignRequestType,
  StorefrontTagUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useProductStorefrontTagAssign = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation<
    StorefrontTagUpdateResponseType,
    unknown,
    StorefrontTagAssignRequestType
  >({
    mutationFn: (data) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `storefront-tags/assign`,
        data,
      }).then(
        (res) =>
          apiV2AssertResponse(res).data as StorefrontTagUpdateResponseType,
      ),

    onSettled: (_data, _error, variables) => {
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.Products,
          variables.ProductId,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.StorefrontTags],
      });
    },
  });
};
